import { Routes } from '@angular/router';
import { PasswordResetPage } from './password-reset/password-reset';
import { NotFoundPage } from './shared/not-found-page/not-found-page';

export const routes: Routes = [
	{
		path: 'password-reset',
		component: PasswordResetPage,
	},
	{
		path: '',
		redirectTo: 'password-reset',
		pathMatch: 'full',
	},
	{
		path: '**',
		component: NotFoundPage,
	},
];
